import React, { useState, useRef, useEffect } from "react";
import { ChevronDown } from "lucide-react";

export interface DropdownItem {
  label: string;
  onClick: () => void;
}

interface DropdownProps {
  label: string | React.ReactNode;
  icon?: React.ReactNode;
  items: DropdownItem[];
  buttonClassName?: string;
}

const FleetrifyActionDropdown: React.FC<DropdownProps> = ({
  label,
  icon,
  items,
  buttonClassName,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => setIsOpen((prev) => !prev);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target as Node)
    ) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="relative inline-block text-left" ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className={`flex items-center text-sm gap-2 px-4 py-2 rounded-md ${
          buttonClassName || "bg-[#143887] text-white"
        }`}
      >
        {icon}
        {label}
        <ChevronDown className="w-4 h-4" />
      </button>

      <div
        className={`transition-all duration-200 ease-in-out origin-top transform ${
          isOpen ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0"
        } absolute z-10 w-full bg-white shadow-lg rounded-md overflow-hidden`}
      >
        {items.map((item, index) => (
          <button
            key={index}
            onClick={() => {
              item.onClick();
              setIsOpen(false);
            }}
            className={`w-full px-4 py-2 text-left text-[#1D1D1D] text-sm hover:bg-gray-100 ${
              index !== items.length - 1 ? "border-b" : ""
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FleetrifyActionDropdown;
